<template>
  <div class="bg-white aspect-square w-full relative rounded-lg mb-16">
    <a class="relative aspect-square flex items-center justify-center w-full" :href="item.attributes.urls.show">
      <img v-if="item.attributes.main_image" :src="item.attributes.main_image" class="object-cover h-full w-full rounded-lg" />
      <span v-else class="fa-stack text-[72px] opacity-20">
        <i class="fa-image far fa-stack-1x" aria-hidden="true"></i>
        <i class="fa-slash fas icon-stack-base fa-stack-1x " aria-hidden="true"></i>
      </span>
      <div class="absolute top-0 p-4 w-full text-xs flex items-center gap-4">
        <div v-if="item.attributes.duration || item.attributes.size" class="bg-white rounded-full p-2 px-3 inline-block">
          <template v-if="item.attributes.itype == 1">
            {{ i18n.t('general.duration') }}:
            {{ item.attributes.duration }}
          </template>
          <template v-if="item.attributes.size">
            {{ i18n.t('general.size') }}:
            {{ item.attributes.size }}
          </template>
        </div>
        <div v-if="item.attributes.delivery_enabled || item.attributes.transport_enabled" class="bg-white rounded-full p-2 inline-block">
          <i class="bi bi-truck text-xl"></i>
        </div>
      </div>
    </a>
    <div class="absolute  w-full pb-4 text-sm flex gap-4 mt-3">
      <a :href="item.attributes.urls.show"
         :class="{
          'w-full': true,
          'w-[calc(100%_-_60px)]': false
         }"
      >
        <div class="flex gap-2 w-full">
          <div class="uppercase grow truncate" :title="item.attributes.name">{{ item.attributes.name }}</div>
          <div v-if="!shopProfile && item.attributes.google_rating" class="shrink-0">
            <span>
              <i class="bi bi-star-fill text-yellow-400"></i>
              <span class="font-bold">{{ item.attributes.google_rating }}</span>
            </span>
          </div>
        </div>
        <div v-if="!shopProfile" class="w-full truncate text-xs">
            <i class="bi bi-geo-alt"></i>
            {{ item.attributes.city }}
          {{ item.attributes.location }}
        </div>
        <div class="uppercase text-right font-bold">
          <template v-if="item.attributes.tiered_price">{{ i18n.t('general.from') }}</template>
          {{ item.attributes.price }}
          {{ item.attributes.currency_symbol }}
          {{ item.attributes.price_unit }}
        </div>
      </a>
      <button v-if="false" class="jt-btn btn-icon ml-auto flex-shrink-0" @click.prevent.stop="bookItem">
        <i class="fas fa-plus"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ItemElemenet',
  props: {
    item: Object,
    shopProfile: String
  },
  methods: {
    bookItem: function() {
      window.topNavigation?.$refs.topNavigation.updateCart(
        this.item.id,
        1
      )
    }
  }
}
</script>